import PropTypes from 'prop-types';

import { ContemporaryLandingMakerRowItem } from './ContemporaryLandingMakerRowItem';

import styles from './ContemporaryLandingMakerRow.scss';

export const ContemporaryLandingMakerRow = ({ items }) => {
    if (!items || !items.length) {
        return null;
    }

    return (
        <div className={styles.makerRow}>
            <div className={`rowFlex ${styles.wrapper}`}>
                {items.map((item, index) => (
                    <ContemporaryLandingMakerRowItem key={`${item.title}-${index}`} item={item} />
                ))}
            </div>
        </div>
    );
};

ContemporaryLandingMakerRow.propTypes = {
    items: PropTypes.array,
};
